import { useQuery } from "@tanstack/react-query";
import { listGamesByCompetition } from "../openapi/api-client.ts";

export const useGameList = (competitionId?: string) => {
  return useQuery({
    queryKey: ["games", { competitionId }],
    enabled: !!competitionId,
    queryFn: async () => {
      if (!competitionId) {
        throw new Error("competitionId is required to fetch games");
      }

      const response = await listGamesByCompetition({
        competitionId,
      });

      return response.data;
    },
  });
};
